<div class="w-full px-6 py-4 bg-white rounded-xl shadow border border-gray-200">
  <!-- ================= HEADER ================= -->
  <div class="flex items-center gap-3 mb-6 w-full flex-wrap">
    <!-- Left section: Back + Title -->
    <div class="flex items-center gap-3">
      <!-- Back Button -->
      <svg
        class="w-6 h-6 cursor-pointer text-c19725"
        [routerLink]="['/admin-panel/stafflistadmin']"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M15 19l-7-7 7-7"
        />
      </svg>

      <div>
        <h2 class="text-2xl font-semibold text-gray-800">Staff Actions</h2>
        <p class="text-sm text-gray-500">
          Managing actions for staff Name:
          <span class="font-medium text-gray-700">{{ staffName }}</span>
        </p>
      </div>
    </div>

    <!-- Right section: Tabs -->
    <div class="ml-auto overflow-x-auto scrollbar-hide mt-4 sm:mt-0">
      <div
        class="grid grid-cols-3 min-w-[360px] sm:min-w-[420px] lg:min-w-[480px] border border-[#D9D9D9] rounded-md overflow-hidden"
      >
        <!-- Issue Stock -->
        <a
          [routerLink]="['/admin-panel/staff', staffId, 'issue-stock']"
          routerLinkActive="bg-c19725 text-white font-medium"
          class="text-center px-4 py-2 text-[#898989] text-sm lg:text-base hover:bg-[#f6f1cb] transition border-l border-r border-[#D9D9D9]"
        >
          Issue Stock
        </a>

        <!-- Categories -->
        <a
          [routerLink]="['/admin-panel/staff', staffId, 'user-access']"
          routerLinkActive="bg-c19725 text-white font-medium"
          [routerLinkActiveOptions]="{ exact: true }"
          class="text-center px-4 py-2 text-[#898989] text-sm lg:text-base hover:bg-[#f6f1cb] transition"
        >
          Access Control
        </a>

        <!-- Assign Assets -->
        <a
          [routerLink]="['/admin-panel/staff', staffId, 'assign-assets']"
          routerLinkActive="bg-c19725 text-white font-medium"
          class="text-center px-4 py-2 text-[#898989] text-sm lg:text-base hover:bg-[#f6f1cb] transition"
        >
          Assign Assets
        </a>
      </div>
    </div>
  </div>

  <!-- <div class="mb-8 border-b border-gray-200">
    <div class="flex gap-2"> -->

      <!-- Access Control -->
      <!-- <a
        [routerLink]="['/admin-panel/staff', staffId, 'user-access']"
        routerLinkActive="bg-c19725 text-white font-medium"
        class="flex-1 text-center px-8 py-3 text-base font-semibold rounded-tr-[5px] border border-[#D9D9D9] text-[#898989] hover:bg-[#f6f1cb] hover:text-black transition"
      >
        Access Control
      </a> -->
      <!-- Issue Stock -->
      <!-- <a
        [routerLink]="['/admin-panel/staff', staffId, 'issue-stock']"
        routerLinkActive="bg-c19725 text-white font-medium"
        [routerLinkActiveOptions]="{ exact: true }"
        class="flex-1 text-center px-8 py-3 text-base font-semibold rounded-tl-[5px] border border-[#D9D9D9] text-[#898989] hover:bg-[#f6f1cb] hover:text-black transition"
      >
        Issue Stock
      </a> -->
    
      <!-- Assign Assets -->
      <!-- <a
        [routerLink]="['/admin-panel/staff', staffId, 'assign-assets']"
        routerLinkActive="bg-c19725 text-white font-medium"
        class="flex-1 text-center px-8 py-3 text-base font-semibold rounded-tr-[5px] border border-[#D9D9D9] text-[#898989] hover:bg-[#f6f1cb] hover:text-black transition"
      >
        Assign Assets
      </a>

      <a
        [routerLink]="['/admin-panel/staff', staffId, 'direct-issue']"
        routerLinkActive="bg-c19725 text-white font-medium"
        class="flex-1 text-center px-8 py-3 text-base font-semibold rounded-tr-[5px] border border-[#D9D9D9] text-[#898989] hover:bg-[#f6f1cb] hover:text-black transition"
      >
        Direct Issue
      </a>

    </div>
  </div> -->

  <!-- ================= TAB CONTENT ================= -->
  <div class="pt-2">
    <router-outlet></router-outlet>
  </div>
</div>
